import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../constants';
import { FormGenerator } from '../../helper/FormGenerator';
import { isNumber } from 'chart.js/helpers';
import { useTokens } from '../../context/TokenContext';

const AdminEditProfile = ({ userData, setUserData }) => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: userData?.name || '',
        phone: userData?.phone || '',
        email: userData?.email || '',
        profile_picture: userData?.profile_picture || '',
    });


    // Handle input changes and update state
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    useEffect(() => {
        setFormData(userData);
    }, []);

    // Handle form submission
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const toastId = toast.loading('Saving your settings...', { autoClose: false });

        try {
            const dataToSend = {
                first_name: formData.first_name,
                last_name: formData.last_name,
                phone: formData.phone,
                profile_picture: formData.profile_picture,
            };

            const response = await axios.put(`${API_URL}/admin/profile`, dataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${adminAuthToken}`,
                },
            });

            if (response.status === 200) {
                toast.update(toastId, {
                    render: 'Settings saved successfully!',
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000,
                });
                setUserData({ ...formData });
            }
            setLoading(false);
        } catch (error) {
            toast.update(toastId, {
                render: 'Failed to save settings. Please try again.',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            });
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Profile</h2>
            <p>Update your profile information below.</p>

            {/* Bootstrap Form */}
            <form onSubmit={handleFormSubmit}>
                <div className='row'>
                    {/* Profile Picture Input using FormGenerator */}
                    <FormGenerator
                        fields={[
                            { id: 'first_name', label: 'First Name', type: 'text', class: 'col-md-6', required: true },
                            { id: 'last_name', label: 'Last Name', type: 'text', class: 'col-md-6', required: true },
            
                            { id: 'phone', label: 'Phone Number', type: 'tel', class: 'col-md-6', required: true, prefix: '+91', minLength: 10, maxLength: 10, isNumeric: true },
                            { id: 'email', label: 'Email', type: 'email', class: 'col-md-6', required: true },
                            { id: 'profile_picture', label: 'Profile Picture', type: "upload_single" }
                        ]}
                        fieldData={formData}
                        onChange={(field, value) => setFormData((prev) => ({ ...prev, [field]: value }))}
                        hTure={false}
                        authToken={adminAuthToken}
                    />
                </div>

                {/* Save Settings Button */}
                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Saving...' : 'Save Settings'}
                </button>
            </form>
        </div>
    );
};

export default AdminEditProfile;
